export enum AddressClientType {
    HABITUAL = 'Habitual',
    RESIDENCE = 'Residence',
}
